import { jsx as _jsx } from "react/jsx-runtime";
import { Field, SearchBox as FluentSearchBox, makeStyles } from "@fluentui/react-components";
import { forwardRef } from "react";
const useStyles = makeStyles({
    search: {
        minWidth: "50px",
    },
});
export const SearchBar = forwardRef((props, ref) => {
    SearchBar.displayName = "SearchBar";
    const classes = useStyles();
    const onChange = (_, data) => {
        props.onChange(data.value);
    };
    return (_jsx(Field, { children: _jsx(FluentSearchBox, { ref: ref, className: classes.search, placeholder: props.placeholder, onChange: onChange }) }));
});
//# sourceMappingURL=searchBar.js.map